<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <div class="body">
            <ng-container *ngFor="let r of consulta?.registros">

                <h2 class="subtitle">{{ r?.identificador }}</h2>
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">CARGO:</span>
                        <span class="text-uppercase">{{ r?.cargo || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CPF:</span>
                        <span class="text-uppercase">{{ r?.cpf || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">NOME:</span>
                        <span class="text-uppercase">{{ r?.nome || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ELEITO EM:</span>
                        <span class="text-uppercase">{{ r?.eleitoEm || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ELEITO ATÉ:</span>
                        <span class="text-uppercase">{{ r?.eleitoAte || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ESTADO CIVIL:</span>
                        <span class="text-uppercase">{{ r?.estadoCivil || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">NACIONALIDADE:</span>
                        <span class="text-uppercase">{{ r?.nacionalidade || msgNull }}</span>
                    </li>
                </ul>

            </ng-container>

        </div>
    </ng-container>

</app-card-consulta>